import {
  parseAdminFeatureEntitlementsResponse,
  parseAdminIntegrationSettings,
  parseAdminTenantSettings,
  parseUpdateAdminTenantSettingsRequest
} from "@madamuh/domain";
import type {
  AdminFeatureEntitlementsResponseDto,
  AdminIntegrationSettingsDto,
  AdminTenantSettingsDto,
  UpdateAdminTenantSettingsRequestDto
} from "@madamuh/domain";
import { apiGet, apiPatch } from "./client";

export async function fetchAdminTenantSettings(tenantSlug: string): Promise<AdminTenantSettingsDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/tenant-settings`);
  return parseAdminTenantSettings(response);
}

export async function patchAdminTenantSettings(
  tenantSlug: string,
  request: UpdateAdminTenantSettingsRequestDto
): Promise<AdminTenantSettingsDto> {
  const parsedRequest = parseUpdateAdminTenantSettingsRequest(request);
  const response = await apiPatch<UpdateAdminTenantSettingsRequestDto, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/tenant-settings`,
    parsedRequest
  );
  return parseAdminTenantSettings(response);
}

export async function fetchAdminIntegrationSettings(tenantSlug: string): Promise<AdminIntegrationSettingsDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/integration-settings`);
  return parseAdminIntegrationSettings(response);
}

export async function fetchAdminFeatureEntitlements(
  tenantSlug: string
): Promise<AdminFeatureEntitlementsResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/feature-entitlements`);
  return parseAdminFeatureEntitlementsResponse(response);
}
